export const getFileNameWithoutExtension = (fileName) =>
  fileName
    ? fileName.replace(/\.[^/.]+$/, '')
    : '';

export const getFileNameWithMaxLenght = (fileName, maxLength) =>
  fileName
    ? fileName.substr(0, maxLength)
    : '';

export const getFileExtensionFromFileName = (fileName) => {
  const re = /(?:\.([^.]+))?$/;

  return re.exec(fileName)[1];
};

export const getFileExtensionFromFileType = (fileType) => {
  if (fileType && fileType.length > 0) {
    return fileType.split('/')[1];
  }

  return null;
};

